import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AdminAddDashboardsList from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardsList';

import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { type FC } from 'react';
import { useParams } from 'react-router-dom';

const AdminAddDashboardsSubarea: FC = () => {
  const { areas } = useAreaContext();
  const { areaId, subareaId } = useParams();
  const area = areas?.find((areaItem) => areaItem.id === areaId);
  const subarea = area?.subareas.find((subareaItem) => subareaItem.id === subareaId);
  const subsubareas = subarea?.subsubareas;

  if (!subsubareas) return <></>;

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        {area?.name} - {subarea.name}
      </Typography>
      <Box>
        <AdminAddDashboardsList
          items={subsubareas}
          navigateURL={(id: string) => `/admin/add-dashboards/areas/${areaId}/${subareaId}/${id}`}
          actions={{
            add: true,
            edit: true,
            delete: true,
          }}
        />
      </Box>
    </>
  );
};

export default AdminAddDashboardsSubarea;
